import availabilitySlice from './availability';

export default {
  availabilitySlice,
};
